const CheckUnread04Icon = /*#__PURE__*/ [
  ["path", { d: "M3.5 5L17.5 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 13.5L6 17L6.73256 16.2326M16.5 6L12.593 10.093", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.5 13.5L11 17L13.1977 14.6977M21.5 6L15.1512 12.6512", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { CheckUnread04Icon as default };
//# sourceMappingURL=CheckUnread04Icon.js.map
